export const SNOWPACK_PUBLIC_SENTRY_ENVIRONMENT = "stable";
export const SNOWPACK_PUBLIC_HUBSPOT_PID = "7739361";
export const SNOWPACK_PUBLIC_OPTIMIZE_HOST = "https://uniform.app";
export const SNOWPACK_PUBLIC_SENTRY_DSN = "https://90f959a56e2341788eaf2fd06160c415@o436918.ingest.sentry.io/5628006";
export const SNOWPACK_PUBLIC_SENTRY_RELEASE = "ad222af23b50c50ff33e534192dc98f0bbc325fb";
export const MODE = "production";
export const NODE_ENV = "production";
export const SSR = false;